/*class ProductOptions extends HTMLElement{constructor(){super()}connectedCallback(){this.first_variant_available="true"===this.dataset.firstVariantAvailable,this.is_product_page=null!==this.closest(".product-page--root"),this.labels=this.querySelectorAll(".disclosure--root, .radios--header"),this.options_container=this.querySelector(".product-options--container"),this.option_inputs=this.options_container.querySelectorAll('[data-item="disclosure"], [data-item="radio"]'),this.root=this.closest(`[data-product-id='${this.dataset.id}']`),this.size_chart=this.querySelector(".product-options--option .product-size-chart--root"),this.variants=JSON.parse(this.querySelector("#product-options--json").innerHTML),this.getAvailableVariants(),this.disableEmptyOptions(),this.optionChangeListener(),this.updateDisabledOptions(this.first_variant_available),this.size_chart&&this.moveSizeChart()}disconnectedCallback(){this.option_inputs.off("change.ProductOptions")}getAvailableVariants(){this.available_variants=[],this.variants.forEach(t=>{t.available&&this.available_variants.push(t.options)})}disableEmptyOptions(){const a=this.available_variants.flat(),t=this.options_container.querySelectorAll(".radios--input, .disclosure--option-link");t.length&&t.forEach(t=>{var i=this.getOptionValue(t);a.includes(i)||t.setAttribute("data-empty",!0)})}getOptionValue(t){return t.getAttribute("data-value")?t.getAttribute("data-value"):t.value}optionChangeListener(){this.option_inputs.on("change.ProductOptions",t=>{const e=[],i=this.options_container.querySelectorAll('[data-item="disclosure"], [data-item="radio"]:checked');i.forEach(t=>{var i=t.closest(".product-options--option").dataset.index;e.push({index:i,value:t.value})});let s=!1;this.variants.every(i=>{let a=!0;return e.forEach(t=>{a=a&&i.options[t.index]===t.value}),!a||(s=i,!1)}),this.updateVariant(s,t.target)})}updateVariant(t,i){this.updateDisabledOptions(t.available,i),this.is_product_page&&this.updateHistoryState(t.id),this.root.trigger("variantUpdated",t)}updateHistoryState(t){let i=""+location.origin+location.pathname;t&&(i+="?variant="+t),history.replaceState({path:i},"",i)}updateDisabledOptions(t,a=!1){const e=this.options_container.querySelectorAll(".radios--input, .disclosure--option-link");if(e.length){const s=[],o=(e.forEach(t=>{t.removeAttribute("data-unavailable"),!t.checked&&"true"!==t.getAttribute("aria-current")||s.push(t)}),this.options_container.querySelectorAll(".disclosure--current-option"));let i;!1===a?(a=s[0],i=this.getOptionValue(a)):a.classList.contains("disclosure--input")?(i=a.value,a=s.find(t=>t.getAttribute("data-value")===i)):i=a.value;const r=[],n=a.closest(".radios--container, .disclosure--form"),l=n.querySelectorAll(".radios--input, .disclosure--option-link"),c=(l.forEach(t=>{t=this.getOptionValue(t);t!==i&&r.push(t)}),r);this.available_variants.forEach(t=>{t.includes(i)&&t.forEach(t=>c.push(t))}),e.forEach(t=>{var i=this.getOptionValue(t);c.includes(i)||t.setAttribute("data-unavailable",!0)}),t?o&&o.forEach(t=>t.setAttribute("data-unavailable",!1)):(s.forEach(t=>t.setAttribute("data-unavailable",!0)),o&&o.forEach(t=>t.setAttribute("data-unavailable",!0)))}}moveSizeChart(){const t=this.size_chart.parentNode.querySelector("label").parentNode;t.appendChild(this.size_chart)}}customElements.define("product-options-root",ProductOptions);
*/
class ProductOptions extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        (this.first_variant_available = "true" === this.dataset.firstVariantAvailable),
            (this.is_product_page = null !== this.closest(".product-page--root")),
            (this.labels = this.querySelectorAll(".disclosure--root, .radios--header")),
            (this.options_container = this.querySelector(".product-options--container")),
            (this.option_inputs = this.options_container.querySelectorAll('[data-item="disclosure"], [data-item="radio"]')),
            (this.root = this.closest(`[data-product-id='${this.dataset.id}']`)),
            (this.size_chart = this.querySelector(".product-options--option .product-size-chart--root")),
            (this.variants = JSON.parse(this.querySelector("#product-options--json").innerHTML)),
            this.getAvailableVariants(),
            this.disableEmptyOptions(),
            this.optionChangeListener(),
            this.updateDisabledOptions(this.first_variant_available),
            this.sectionid = this.getAttribute('data-section');
            this.purl = this.getAttribute('purl');
            console.log(this.sectionid)
            this.size_chart && this.moveSizeChart();
            
    }
    disconnectedCallback() {
        this.option_inputs.off("change.ProductOptions");
    }
    getAvailableVariants() {
        (this.available_variants = []),
            this.variants.forEach((t) => {
                t.available && this.available_variants.push(t.options);
            });
    }
    disableEmptyOptions() {
        const a = this.available_variants.flat(),
            t = this.options_container.querySelectorAll(".radios--input, .disclosure--option-link");
        t.length &&
            t.forEach((t) => {
                var i = this.getOptionValue(t);
                a.includes(i) || t.setAttribute("data-empty", !0);
            });
    }
    getOptionValue(t) {
        return t.getAttribute("data-value") ? t.getAttribute("data-value") : t.value;
    }
    optionChangeListener() {
        this.option_inputs.on("change.ProductOptions", (t) => {
            const e = [],
                i = this.options_container.querySelectorAll('[data-item="disclosure"], [data-item="radio"]:checked');
            i.forEach((t) => {
                var i = t.closest(".product-options--option").dataset.index;
                e.push({ index: i, value: t.value });
            });
            let s = !1;
            this.variants.every((i) => {
                let a = !0;
                return (
                    e.forEach((t) => {
                        a = a && i.options[t.index] === t.value;
                    }),
                    !a || ((s = i), !1)
                );
            }),
                this.updateVariant(s, t.target);
        });
    }
    updateVariant(t, i) {
        this.updateDisabledOptions(t.available, i), this.is_product_page && this.updateHistoryState(t.id), this.root.trigger("variantUpdated", t);
     
    }
   async updateHistoryState(t) {
        let i = "" + location.origin + location.pathname;
        t && (i += "?variant=" + t), history.replaceState({ path: i }, "", i);
     let pri = await fetch(`${theme.urls.root}${this.purl}?variant=${t}&section_id=${this.sectionid}`);

     if (pri.ok){
        let pridata = await pri.text();
        let pridatanew = theme.utils.parseHtml(pridata, ".product-price--root");
         let existingElement = document.querySelector(".product-price--root");
      if (existingElement) {
        existingElement.outerHTML = pridatanew.outerHTML;
      }
     }
    }
    updateDisabledOptions(t, a = !1) {
        const e = this.options_container.querySelectorAll(".radios--input, .disclosure--option-link");
        if (e.length) {
            const s = [],
                o =
                    (e.forEach((t) => {
                        t.removeAttribute("data-unavailable"), (!t.checked && "true" !== t.getAttribute("aria-current")) || s.push(t);
                    }),
                    this.options_container.querySelectorAll(".disclosure--current-option"));
            let i;
            !1 === a ? ((a = s[0]), (i = this.getOptionValue(a))) : a.classList.contains("disclosure--input") ? ((i = a.value), (a = s.find((t) => t.getAttribute("data-value") === i))) : (i = a.value);
            const r = [],
                n = a.closest(".radios--container, .disclosure--form"),
                l = n.querySelectorAll(".radios--input, .disclosure--option-link"),
                c =
                    (l.forEach((t) => {
                        t = this.getOptionValue(t);
                        t !== i && r.push(t);
                    }),
                    r);
            this.available_variants.forEach((t) => {
                t.includes(i) && t.forEach((t) => c.push(t));
            }),
                e.forEach((t) => {
                    var i = this.getOptionValue(t);
                    c.includes(i) || t.setAttribute("data-unavailable", !0);
                }),
                t ? o && o.forEach((t) => t.setAttribute("data-unavailable", !1)) : (s.forEach((t) => t.setAttribute("data-unavailable", !0)), o && o.forEach((t) => t.setAttribute("data-unavailable", !0)));
        }
    }
    moveSizeChart() {
        const t = this.size_chart.parentNode.querySelector("label").parentNode;
        t.appendChild(this.size_chart);
    }
}
customElements.define("product-options-root", ProductOptions);
